import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Paper,
  TextField,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";



const Chatbot = ({ userId, apiBase = "http://ec2-43-205-136-189.ap-south-1.compute.amazonaws.com" }) => {
//const Chatbot = ({  userId, apiBase = "http://127.0.0.1:8000" }) => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const token = localStorage.getItem("labour_law_token");

  const [messages, setMessages] = useState([
    { role: "Law Bot", text: "Hello — ask me anything about the Labour Law Acts." },
  ]);

  const listRef = useRef(null);
  const getSessionKey = () => {
    let sid = localStorage.getItem("chat_session_id");
    if (!sid) {
      sid = window?.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : "sid-" + Math.random().toString(36).slice(2, 10);
      localStorage.setItem("chat_session_id", sid);
    }
    return sid;
  };
  // Auto scroll
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = async (text) => {
    if (!text.trim()) return;

    const userMsg = { role: "user", text: text.trim() };
    setMessages((m) => [...m, userMsg]);
    setInput("");
    setSending(true);

    try {
      const session_key = getSessionKey();
      const res = await axios.post(
        `${apiBase}/docsearch/chatbot/`,
        { session_key, message: text.trim(), userId },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}`, } }
      );

      const data = res?.data || {};
      setMessages((m) => [
        ...m,
        {
          role: "assistant",
          text: data.reply ?? "No reply.",
          askCompliance: data.ask_compliance_forms || false,
          metadata: data.metadata || {},
          forms: [],
        },
      ]);

    } catch (err) {
      setMessages((m) => [
        ...m,
        { role: "assistant", text: "Server error." },
      ]);
    }

    setSending(false);
  };
  function renderWithLinks(text) {
    const urlRegex = /(https?:\/\/[^\s)]+)(?=[)\s]?)/g;

    return text.split("\n").map((line, index) => {
      const parts = line.split(urlRegex);

      return (
        <Typography
          component="span"
          key={index}
          sx={{ display: "block", mb: 1 }}
        >
          {parts.map((part, i) =>
            urlRegex.test(part) ? (
              <a
                key={i}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", wordBreak: "break-all" }}
              >
                📄 View Document
              </a>
            ) : (
              part
            )
          )}
        </Typography>
      );
    });
  }

  const handleYesCompliance = async (metadata) => {
    try {
      const session_key = getSessionKey();

      const res = await axios.post(
        `${apiBase}/docsearch/chatbot/`,
        {
          session_key,
          message: "__YES__",
          metadata: {
            action: "YES_COMPLIANCE_FORMS",
            ...metadata,
          },
          userId,
        },
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}`, } }
      );

      const data = res?.data || {};

      setMessages((m) => [
        ...m,
        {
          role: "assistant",
          text: data.reply || "Here are the relevant compliance documents:",
          forms: data.forms || [],
        },
      ]);
    } catch (err) {
      setMessages((m) => [
        ...m,
        { role: "assistant", text: "Failed to load compliance documents." },
      ]);
    }
  };



  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "90%",
        minHeight: 0, // IMPORTANT
      }}
    >
      {/* Messages container */}
      <Box
        ref={listRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          padding: 2,
          minHeight: 0, // IMPORTANT
        }}
      >
        <List>
          {messages.map((m, i) => (
            <ListItem key={i} sx={{ alignItems: "flex-start" }}>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {m.role === "user"
                      ? "You"
                      : m.role === "assistant"
                      ? "LawBot"
                      : "System"}
                                      
                  </Typography>
                }
                secondary={
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", wordBreak: "break-word",mt: 0.5 }}
                  >
                    {renderWithLinks(m.text)}
                    {/* YES / NO buttons */}  
                    {m.askCompliance && (
                      <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          Would you like to see the relevant compliance forms?
                        </Typography>
                        <button
                          onClick={() => handleYesCompliance(m.metadata)}
                          style={{ padding: "4px 10px", cursor: "pointer" }}
                        >
                          Yes
                        </button>
                      </Box>
                    )}
                    {m.forms && m.forms.length > 0 && (
                      <Box sx={{ mt: 1 }}>
                        {m.forms.map((f, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              border: "1px solid #ddd",
                              p: 1,
                              borderRadius: 1,
                              mb: 1,
                              background: "#fafafa",
                            }}
                          >
                            {/* ✅ FORM NAME */}
                            <Typography fontWeight={600}>
                              {f.name}
                            </Typography>

                            {/* ✅ STATE + DOMAIN */}
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary", display: "block", mb: 0.5 }}
                            >
                              {f.state && <>📍 State: <b>{f.state}</b></>}
                              {f.state && f.domain && " | "}
                              {f.domain && <>🏷️ Domain: <b>{f.domain}</b></>}
                            </Typography>
                            {/* <Typography variant="body2" sx={{ mb: 0.5 }}>
                              {f.description}
                            </Typography> */}
                            <a
                              href={f.download_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              📄 View / Download
                            </a>
                          </Box>
                        ))}
                      </Box>
                    )}


                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Input bar */}
      <Box
        sx={{
          padding: 1,
          display: "flex",
          gap: 1,
          borderTop: "1px solid #ddd", // optional better UI
          background: "#fff",          // prevents overlap
        }}
      >
        <TextField
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask something..."
          fullWidth
          size="small"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              sendMessage(input);
            }
          }}
        />
        <IconButton
          color="primary"
          onClick={() => sendMessage(input)}
          disabled={sending}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </Paper>

  );
};

export default Chatbot;